var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHearth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.916664 52.916668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m38.5344,1.2119c-4.6461,0 -9.3766,2.3701 -12.0761,7.3651 -0.7323,-1.3559 -1.6112,-2.5185 -2.5955,-3.4932 -2.6581,-2.6324 -6.0844,-3.8946 -9.4658,-3.8946 -6.7129,0 -13.2465,4.9745 -13.2465,14.082 0,10.6018 11.7492,21.4471 25.3078,35.9589 13.5608,-14.5119 25.3078,-25.3571 25.3078,-35.9589 0,-9.1234 -6.5273,-14.0592 -13.2318,-14.0592",
    strokeOpacity: 0.850807,
    strokeWidth: 1.07019,
    stroke: "#ff6600ff",
    fillRule: "evenodd",
    id: "path_0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHearth);
export default __webpack_public_path__ + "static/media/ic_hearth.c5af9a970734d314a06208704969bf74.svg";
export { ForwardRef as ReactComponent };